import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'wcg-ui-header-wrapper',
  styleUrl: './ui-header-wrapper.component.scss',
  template: `
    <div class="ui-header-wrapper">
      <div class="flex justify-between items-center header">
        <div class="flex gap-16 items-center">
          <section class="header-title-section">
            <ng-content select="[wcgHeaderTitle]" />
          </section>

          <section class="header-actions-section">
            <ng-content select="[wcgHeaderActions]" />
          </section>
        </div>

        <section class="header-controls-section">
          <ng-content select="[wcgHeaderControls]" />
        </section>
      </div>
    </div>
  `,
})
export class UiHeaderWrapperComponent {
  // This component provides a reusable header wrapper
  // It uses content projection to allow any header content to be wrapped
}
